import useConfig from '@/composables/useConfig';
import { SYSTEM_VARIABLES_MAP, VARIABLE_VALUE_TYPES } from '@/js/constants';

export function onSttTextCb({ text }) {
  const { setVariables } = useConfig();
  setVariables([{
    id: SYSTEM_VARIABLES_MAP.VOICE_INPUT.id,
    value: { value: text, type: VARIABLE_VALUE_TYPES.PRIMITIVE },
  }]);
}
